import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../../utils/apollo/api'
import { getInvite } from '../../_helpers/queryParams'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormReplyState = () => React.useContext(Context)
export const useFormReply = () => useFormReplyState().formReply

const QUERY = gql`
  query FormReply($inviteCode: String) {
    formReply(inviteCode: $inviteCode) {
      id
      insertedAt
    }
  }
`

const FormReplyLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { inviteCode: getInvite() },
    client: formsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormReplyLoader
